import { Link } from "react-router-dom";

function AccountCreated() {
    return (<>
        <div className="page">
            <h1 className="center">Account Created!</h1>
        </div>
    </>)
}

export default AccountCreated;